<template>
<div>

    <headerNav title="我的地址"/>
    
    <div class="vinfos">
        <van-sticky>
   <van-field
  v-model="filter"
  center
  clearable
  label="筛选条件"
  placeholder="姓名/手机号"
>
  <template #button>
    <van-button size="small" type="primary" @click="loaddata">搜索</van-button>
  </template>
</van-field>
</van-sticky>
       
        <van-swipe-cell  v-for="(item,index) in list"  :key="index">
        <div class="vinfo">
                 <div @click="selectitem(item)">
                    <div class="vinfo-content">
                        <div class="vinfo-mm">
                            <span class="vinfo-name">{{item.receiverName}}</span>
                            <span class="vinfo-phone">{{item.receiverMobile}}</span>
                            <van-tag type="danger" v-if="item.isDefault" style="margin-right:5px">默认</van-tag>
                            <!-- <van-tag type="primary" v-if="item.isAuthCard">认证</van-tag>
                            <van-tag type="danger" v-if="!item.isAuthCard">未认证</van-tag> -->
                        </div>
                        <div style="margin-bottom:5px">
                            {{item.province+item.receiverCity+item.receiverDistrict+item.receiverAddress}}
                        </div>
                        <div v-if="item.cardNo">
                            {{item.cardNo}}
                        </div>
                    </div>
                    <div class="vinfo-pic" @click.stop="onEdit(item)">
                    
                            <van-icon name="edit" style="height:100%;width:100%"  :size="20"/>
                    </div>
                </div>
            </div>
             <template #right>
                <van-button square type="danger" @click="onDelete(item)" style="height:100%;" text="删除" />
            </template>
        </van-swipe-cell>
        <div style="margin:100px"></div>
    </div>
     
    <div class="ftbtns">
        <van-button type="primary" @click="onAdd" class="setbtns" :color="$abctheme.basecolor" style="width:80%;margin:10px;">新增地址</van-button>
    </div>

    <!-- <van-address-list
        :class="isSelect?'':'hideselect'"
        :list="list"
        default-tag-text="默认"
        :switchable="false"
        @add="onAdd"
        @edit="onEdit"
        @click-item="selectitem"
    >
    <template #tag prop="vinfo">

    </template>
    </van-address-list> -->
</div>
</template>

<script>
import request from "@/config/ajax";
import eventBus from '@/config/eventbus';
export default {
    data() {
        return {
        chosenAddressId: '1',
        isSelect:false,
        list: [],
        isedit:false,
        state:0,
        filter:''
        }
    },
    watch:
    {
        '$route': 'loaddata'
    },
    created()
    {
        var option=this.$route.query;
        if(option.state)
        {
            this.state=option.state;
        }
        this.loaddata();
        
    },
    methods: {
        loaddata() {
            request.post('/api/services/app/PhoneUser/QueryAddressList',{filter:this.filter}).then(x => {
                this.list = x.result;
            })
        },
        onAdd() {
           
            this.$router.push({name:'addressedit',query:{type:'add'}})
        },
        onEdit(item) {
            
            if(!this.isedit)
            {
                this.isedit=true;
            }
            
            this.$router.push({name:'addressedit',query:{type:'edit',address:item}})

            // this.$router.push({path:'/user/address/edit',params:{type:'edit'}});
        },
        onDelete(data) {
            request
                .delete("/api/services/app/PhoneUser/DeleteAddress?id=" + data.id)
                .then(() => {
                this.$toast("删除成功");
                this.loaddata();
                });
        },
        selectitem(item)
        {
            
            if(this.isedit)
            {
                this.isedit=false;
                return;
            }
            
            if(this.state==0)
            {
                eventBus.$emit('changeaddress',item);
                localStorage.setItem('changeaddress',item.id);
                //调用router回退页面
                this.$router.go(-1);
            }
        }
    },
    

}
</script>

<style lang="scss" scoped>
.vinfos{
    padding: 10px;
}
.vinfo{
    border-radius: 4px;
    background-color: #fff;
    font-size: 12px;
    margin-bottom: 10px;
    padding: 18px;
}
.vinfo-content{
    display: inline-block;
    width: 75%;
}
.vinfo-mm{
    font-size: 16px;
    margin-bottom: 10px;
}
.vinfo-name{
    margin-right: 10px;
}
.vinfo-pic{
    display: inline-block;
    width: 20%;
    text-align: right;
    height: 100%;
    vertical-align: 10px;
}
.vinfo-phone{
    margin-right: 8px;
}
.ftbtns{
    position:fixed;
    bottom: 0;
    left:0;
    right:0;
    text-align: center;
    background-color: #fff;
}
.hideselect{
    .van-radio__input{
        display: none;
    }
    .van-button{
        background: #FDD108;
        border-color: #FDD108;
    }
}
</style>
